import ActionManager from "./base";
import { statsRequestStart, statsRequestSuccess, statsRequestError } from "../actions/stats";
import statsAPI from "../api/stats";
import DefaultActionManager from "./default_action_manager";
import { stringify } from "querystring";
import { getUserTimezone } from "../lib/timezones";

export const fetchGeoStatsActionName = "FETCH_GEO_STATS";
export class DownloadStatsActionManager extends ActionManager {
  defaultErrorMessage() {
    return "Uh oh, something went wrong fetching stats. Please try again later.";
  }

  preCall(dispatch) {
    dispatch(statsRequestStart(this.args.requestID));
  }

  execute() {
    return statsAPI.fetchDownloads(this.args.filters, this.args.user);
  }

  responseOK(dispatch, json) {
    dispatch(statsRequestSuccess(this.args.requestID, json));
  }

  response400(dispatch, json) {
    this.responseError(dispatch, 400, json);
  }

  responseError(dispatch, statusCode, json) {
    var errorMessage = json.errorMessage || json.message || this.defaultErrorMessage();
    dispatch(statsRequestError(this.args.requestID));
    this.showError(dispatch, errorMessage);
  }

  // Handles unknown exceptions.  Override for customizations.
  catchError(dispatch, err) {
    dispatch(statsRequestError(this.args.requestID));
    this.showError(dispatch, this.defaultErrorMessage());
  }
}

export class InsertionStatsActionManager extends DownloadStatsActionManager {
  execute() {
    return statsAPI.fetchInsertions(this.args.filters, this.args.user);
  }
}

export function fetchGeoStats(filters, requestID) {
  var finalFilters = {
    timezone: getUserTimezone(),
  };
  Object.keys(filters).forEach(item => {
    if (filters[item]) {
      finalFilters[item] = filters[item];
    }
  });
  return new DefaultActionManager({
    auth: true,
    route: `stats/downloads-by-geo?${stringify(finalFilters)}`,
    actionName: fetchGeoStatsActionName,
    requestID,
  }).run();
}
